import { LineSessionDao } from '@raysee/dao';
import { useRouter } from 'next/router';
import { useAsyncCallback } from 'react-async-hook';

const lineLinkage = (tellerId: string) =>
  LineSessionDao()
    .add({
      rayseeId: tellerId,
      createTime: new Date(),
      updateTime: new Date(),
    })
    .then((sessionId) => {
      const url = new URL(`${process.env.NEXT_PUBLIC_LINE_AUTH_URL}/oauth2/v2.1/authorize`);
      url.searchParams.append('response_type', 'code');
      url.searchParams.append('client_id', process.env.NEXT_PUBLIC_LINE_CHANNEL_ID);
      url.searchParams.append('redirect_uri', process.env.NEXT_PUBLIC_LINE_REDIRECT_URI);
      url.searchParams.append('scope', 'profile');
      url.searchParams.append('state', sessionId);
      url.searchParams.append('bot_prompt', 'aggressive');
      return url.href;
    });

export const useLineLinkage = () => {
  const router = useRouter();
  const { execute, loading, error } = useAsyncCallback(lineLinkage);

  return {
    execute: (tellerId: string) => execute(tellerId).then((url) => router.push(url)),
    loading,
    error,
  };
};
